/**
 * @fileoverview Photo modal - used with the SfPhotoCarousel for now,
 * but may be repurposed for other items in the future
 *
 * @author david@blackairplane.com (David Leggett)
 */

class SfPhotoModal {
    constructor() {
        this.modal = null
        this.photoEl = null
        this.contentEl = null
        this.titleEl = null
        this.instaEl = null

        this.setupModal()
    }

    setupModal() {
        this.modal = document.createElement('div')
        const modalFadeEl = document.createElement('div')
        this.photoEl = document.createElement('div')
        this.contentEl = document.createElement('div')
        this.titleEl = document.createElement('div')
        const layoutEl = document.createElement('div')
        const primaryContentEl = document.createElement('div')

        this.modal.classList.add('sf-photo-modal')
        modalFadeEl.classList.add('sf-photo-modal__fade')
        this.photoEl.classList.add('sf-photo-modal__photo')
        this.titleEl.classList.add('sf-photo-modal__title')
        this.contentEl.classList.add('sf-photo-modal__content')
        layoutEl.classList.add('sf-photo-modal__box')
        primaryContentEl.classList.add('sf-photo-modal__primary-content')


        this.modal.appendChild(modalFadeEl)
        layoutEl.appendChild(this.photoEl)
        layoutEl.appendChild(primaryContentEl)
        // Moved to addInstagramLogo method to clean up this a little
        this.addInstagramLogo(primaryContentEl);
        primaryContentEl.appendChild(this.titleEl)
        primaryContentEl.appendChild(this.contentEl)
        this.modal.appendChild(layoutEl)


        document.body.appendChild(this.modal)

        modalFadeEl.addEventListener('click', () => {
            this.closeModal()
        })
    }

    addInstagramLogo( element ) {
        // Create DIV
        const instaEle = document.createElement('div');
        // Add class
        instaEle.classList.add('sf-photo-modal__insta-icon');
        // Add SVG icon
        instaEle.innerHTML = `<?xml version="1.0" encoding="UTF-8"?>
        <svg width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-713.000000, -529.000000)" fill="#858585" fill-rule="nonzero">
                    <g transform="translate(0.000000, 433.000000)">
                        <path d="M744.908129,139.968781 C748.414019,139.802747 751.519461,139.001948 754.078068,136.433614 C756.636579,133.875007 757.437377,130.769565 757.613139,127.263676 C757.818274,123.650403 757.818274,112.830136 757.613139,109.216863 C757.4472,105.710974 756.646402,102.605532 754.078068,100.046925 C751.519461,97.4884136 748.414019,96.6876152 744.908129,96.5118534 C741.294857,96.3067186 730.464766,96.3067186 726.851494,96.5118534 C723.355427,96.6777924 720.249985,97.4785908 717.681651,100.037198 C715.113317,102.595804 714.322246,105.701246 714.146484,109.207136 C713.941445,112.820408 713.941445,123.650403 714.146484,127.263676 C714.312518,130.769565 715.113317,133.875007 717.681651,136.433614 C720.249985,138.992221 723.3457,139.792924 726.851494,139.968781 C730.464766,140.173821 741.294857,140.173821 744.908129,139.968781 Z M735.884675,136.179651 C732.701127,136.179651 725.855479,136.433614 722.984354,135.300747 C721.070334,134.539049 719.595671,133.064482 718.824245,131.140639 C717.681651,128.259786 717.945341,121.423865 717.945341,118.240317 C717.945341,115.056674 717.691378,108.211025 718.824245,105.3399 C719.585943,103.42588 721.060511,101.951217 722.984354,101.179792 C725.769178,100.075284 732.249794,100.284871 735.554428,100.300071 L735.884675,100.300888 C739.068319,100.300888 745.913967,100.046925 748.785092,101.179792 C750.699112,101.94149 752.173775,103.416058 752.945201,105.3399 C754.049709,108.124724 753.840122,114.60534 753.824922,117.91006 L753.824105,118.240317 C753.824105,121.423865 754.087795,128.269514 752.945201,131.140639 C752.183503,133.054659 750.708935,134.529322 748.785092,135.300747 C745.90424,136.443342 739.068319,136.179651 735.884675,136.179651 Z M747.564392,109.177763 C749.009682,109.177763 750.181554,108.015713 750.181554,106.5606 C750.181554,105.11531 749.009682,103.943438 747.564392,103.943438 C746.119102,103.943438 744.94723,105.11531 744.94723,106.5606 C744.94723,108.00589 746.109279,109.177763 747.564392,109.177763 Z M735.884675,129.460936 C742.095655,129.460936 747.10539,124.451202 747.10539,118.240317 C747.10539,112.029337 742.095655,107.019603 735.884675,107.019603 C729.673791,107.019603 724.664056,112.029337 724.664056,118.240317 C724.664056,124.451202 729.673791,129.460936 735.884675,129.460936 Z M735.884675,125.535145 C731.871051,125.535145 728.589847,122.263669 728.589847,118.240317 C728.589847,114.21687 731.861324,110.945394 735.884675,110.945394 C739.908122,110.945394 743.179599,114.21687 743.179599,118.240317 C743.179599,122.263669 739.898395,125.535145 735.884675,125.535145 Z"></path>
                    </g>
                </g>
            </g>
        </svg>
        `;
        // Append to element        
        element.appendChild(instaEle)
    }

    openModal(photo, content, title, showInstagramLogo = false) {
        this.modal.classList.add('sf-photo-modal--open')

        if (showInstagramLogo) {
            this.modal.classList.add('sf-photo-modal--w-insta')
        }

        this.photoEl.style.backgroundImage = 'url(' + photo + ')'
        this.contentEl.innerHTML = content
        this.titleEl.innerHTML = title
    }

    closeModal() {
        this.photoEl.style.backgroundImage = ``
        this.contentEl.innerHTML = ``
        this.titleEl.innerHTML = ``
        this.modal.classList.remove('sf-photo-modal--open', 'sf-photo-modal--w-insta')
    }
}

export default SfPhotoModal
